import templateScorecardExport from '../../../../../../Template/config/components/scorecard/ScorecardView/ScorecardExport';
export default {
  ...templateScorecardExport,
  columnWidths: {
    metricsLabels: 35,
    norm: 10,
    metrics: 15
  },
  defaultAlignment: 'center',
  defaultRowHeight: 15,
  defaultFontSize: 10,
  styles: {
    h1: {
      type: 'header',
      height: 25,
      format: {
        fill: '#eeeeee',
        color: '#002C59',
        font: {
          size: 12,
          bold: true
        }
      }
    },
    d0: {
      type: 'metric',
      height: 15,
    },
    d1: {
      type: 'metric',
      height: 15,
      offset: '        '
    },
    eol: {
      type: 'header',
      height: 20
    }
  },

  sheetHeaders: [
    {
      field: 'brand',
      metricsLabel: 'Brand',
      alignment: 'center'
    },
    {
      field: 'thumbnail',
      rowHeight: 50,
      normLabel: 'NORM',
      alignment: 'center',
      font: {
        bold: true,
        size: 12
      }
    },
    {
      field: 'ad_code',
      rowHeight: 25,
      metricsLabel: 'Ad Code',
      alignment: 'center',
      font: {
        bold: true,
        size: 12
      }
    },
    {
      field: 'title',
      metricsLabel: 'Title',
      alignment: 'center'
    },
    {
      field: 'length',
      metricsLabel: 'Ad Length'
    },
    {
      field: 'n',
      metricsLabel: 'Sample Size',
      font: {
        bold: true
      }
    },
    {
      field: 'first_air_date',
      metricsLabel: 'First Air Date'
    },
    {
      field: 'product_campaign',
      metricsLabel: 'Product Campaign',
      font: {
        italic: true
      }
    },
    {
      field: 'last_month_tested',
      metricsLabel: 'Last Month Tested',
    }
  ]
};



// WEBPACK FOOTER //
// ./src/app/configuration/Discover/config/components/scorecard/ScorecardView/ScorecardExport/index.js